import { useState, type CSSProperties } from "react";
import { ArrowUpRight } from "lucide-react";
import "./deploy.css";

// This is a presentation surface. The button intentionally has no deployment action.
export function GalleryDeployView({ style }: { style?: CSSProperties } = {}) {
  const [clicked, setClicked] = useState(false);
  return <section className="gallery-deploy-view" style={style} aria-label="Real robot deployment">
    <h2>Try it on a<br /><span>real robot?</span></h2>
    <button type="button" className={`gallery-deploy-button${clicked ? " is-clicked" : ""}`} aria-pressed={clicked} onClick={() => setClicked(true)}>Deploy <ArrowUpRight size={28} strokeWidth={1.6} /></button>
  </section>;
}
